import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BaseQuestionGradingComponent } from '../../../../question-v2/bases';
import { useQuestionContext } from '../../../../question-v2/core';
import { AnswerItemComponent } from './components';
import styled from 'styled-components';
import { Space } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledAnswerContainer = styled(Space).withConfig({
  displayName: "single-choice-gradingcomponent__StyledAnswerContainer",
  componentId: "sc-10zaorr-0"
})(["width:100%;"]);

var isAnswerCorrect = function isAnswerCorrect(correctAnswers, answerId) {
  return correctAnswers.some(function (c) {
    return c.answerId === answerId;
  });
};

var isAnswerSelected = function isAnswerSelected(selectedAnswerId, answerId) {
  return selectedAnswerId === answerId;
};

export var SingleChoiceGradingComponent = function SingleChoiceGradingComponent(_ref) {
  var _answer$value;

  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var singleChoiceQuestion = question;
  var isSkipped = states.isSkipped,
      answer = states.answer,
      isQuestionCorrect = states.isCorrect,
      _states$isResponderVi = states.isResponderView,
      isResponderView = _states$isResponderVi === void 0 ? false : _states$isResponderVi,
      label = states.label;
  var selectedAnswerId = answer === null || answer === void 0 ? void 0 : (_answer$value = answer.value) === null || _answer$value === void 0 ? void 0 : _answer$value.answerId;
  var isManuallyAwarded = !isQuestionCorrect && !!(answer !== null && answer !== void 0 && answer.hasGraded()) && typeof (answer === null || answer === void 0 ? void 0 : answer.score) === 'number' && answer.score > 0;
  var statusColorProps = {
    colorStatusCorrect: label === null || label === void 0 ? void 0 : label.colorStatusCorrect,
    colorStatusIncorrect: label === null || label === void 0 ? void 0 : label.colorStatusIncorrect,
    colorStatusCustomGrade: label === null || label === void 0 ? void 0 : label.colorStatusCustomGrade
  };

  var renderAnswers = function renderAnswers() {
    if (isSkipped) {
      return singleChoiceQuestion.answers.map(function (a, index) {
        var isCorrect = isAnswerCorrect(singleChoiceQuestion.correctAnswers || [], a.id.toString());
        return /*#__PURE__*/_jsx(AnswerItemComponent, _objectSpread({
          answerId: a.id.toString(),
          description: a.description,
          isCorrect: isCorrect,
          isSelected: false,
          index: index,
          isResponderView: isResponderView
        }, statusColorProps), a.id.toString());
      });
    }

    return singleChoiceQuestion.answers.map(function (a, index) {
      var isSelected = isAnswerSelected(selectedAnswerId, a.id.toString());
      var isCorrect = isAnswerCorrect(singleChoiceQuestion.correctAnswers || [], a.id.toString());
      return /*#__PURE__*/_jsx(AnswerItemComponent, _objectSpread({
        answerId: a.id.toString(),
        description: a.description,
        isCorrect: isCorrect,
        isSelected: isSelected,
        index: index,
        isResponderView: isResponderView,
        isManuallyAwarded: isManuallyAwarded
      }, statusColorProps), a.id.toString());
    });
  };

  return /*#__PURE__*/_jsx(BaseQuestionGradingComponent, {
    states: states,
    actions: actions,
    children: /*#__PURE__*/_jsx(StyledAnswerContainer, {
      direction: "vertical",
      size: "middle",
      children: renderAnswers()
    })
  });
};